module.exports = __webpack_public_path__ + "img/w5-b1.09dc3f9e.jpg";